module.exports = __webpack_public_path__ + "static/img/Header-lg.a503ec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Header-lg.png
// module id = J8fk
// module chunks = 0